import { Box, SxProps, Theme } from '@mui/material';

interface Props {
  color: string;
  size?: number;
  selected?: boolean;
  sx?: SxProps<Theme>;
}

const CategoryColor = ({ color, size = 16, selected = true, sx }: Props) => {
  return (
    <Box
      component="span"
      sx={[
        {
          bgcolor: color,
          width: size,
          height: size,
          borderRadius: '100%',
          border: '2px solid rgba(255,255,255,0.2)',
        },
        {
          opacity: selected ? 1 : 0.5,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
};

export default CategoryColor;
